import api from './api';
import type { FeeSchedule, CreateFeeSchedulePayload, UpdateFeeSchedulePayload } from '@/types/fee_schedule_schema';

export const feeScheduleApi = {
  async getSchedules(academicYearId?: number): Promise<FeeSchedule[]> {
    const params = academicYearId ? { academic_year_id: academicYearId } : {};
    const response = await api.get('/fee-management/schedules', { params });
    return response.data.data ?? [];
  },

  async getFrequencyOptions(term: number): Promise<string[]> {
    const response = await api.get('/fee-management/schedules/frequency-options', { params: { term } });
    return response.data.data ?? [];
  },

  async createSchedule(payload: CreateFeeSchedulePayload): Promise<FeeSchedule> {
    const response = await api.post('/fee-management/schedules', payload);
    return response.data.data;
  },

  async updateSchedule(id: number, payload: UpdateFeeSchedulePayload): Promise<FeeSchedule> {
    const response = await api.put(`/fee-management/schedules/${id}`, payload);
    return response.data.data;
  },

  async deleteSchedule(id: number): Promise<void> {
    await api.delete(`/fee-management/schedules/${id}`);
  },
};

export default feeScheduleApi;
